export const HOME_BUTTON = 'home';
export const CARD_BUTTON = 'perpay-card';
export const SHOP_BUTTON = 'shop';
export const MARKETPLACE_BUTTON = 'perpay-marketplace';
export const SUPPORT_BUTTON = 'support';
